// extracted by mini-css-extract-plugin
export default {"Singup":"Singup_Singup__WLYI8","name":"Singup_name__xiVfG","button":"Singup_button__muRkb","submit":"Singup_submit__OitWt"};